import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ModalCliente from '../Clientes/Modal';
import ModalLoteo from "../Loteos/Modal";
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker";
import ParadigmaCurrencyInput from "../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";
import ParadigmaDatePicker from "../../components/ParadigmaDatePicker/ParadigmaDatePicker";
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput";
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";
import { Monedas } from '../Monedas/Monedas/constants.js'
import { formatCurrency } from '../../functions/functions';
import { getMonedas } from "../../api/apicalls.js";

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fecha: moment(),
            vendedor_id: null,
            cliente_id: null,
            loteo_id: null,
            lote_id: null,
            comentarios: '',
            monedas: [], // Todas las Monedas de la api
            moneda: null, // Moneda para el Input (object)
            monto: '0',
            seña: '0',
            cantidadCuotas: 0,

            postVariables: [
                'fecha',
                'vendedor_id',
                'cliente_id',
                'loteo_id',
                'lote_id',
                'comentarios',
                'monto',
                'seña',
                'cantidadCuotas'
            ],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    async componentDidMount() {
        const monedas = await getMonedas();
        const monedaPesos = monedas
            ? monedas.find(moneda => moneda.id === Monedas.PESOS)
            : null;

        this.setState({ 
            monedas,
            moneda: monedaPesos,
        });
    }

    findMoneda = (monedaId) => {
        const { monedas } = this.state

        const moneda = monedas
            ? monedas.find(moneda => moneda.id === monedaId)
            : null;

        return moneda
    }

    getMonedaSimbolo = () => {
        const { moneda } = this.state
        return moneda ? moneda.simbolo : ""
    }

    resetForm() {
        const monedaPesos = this.findMoneda(Monedas.PESOS);

        this.setState({
            fecha: moment(),
            vendedor_id: null,
            cliente_id: null,
            loteo_id: null,
            lote_id: null,
            comentarios: '',
            moneda: monedaPesos,
            monto: '0',
            seña: '0',
            cantidadCuotas: 0,
            errors: [],
        });
    }

    getData() {
        const { 
            postVariables,
            moneda,
        } = this.state;
        const monedaId = moneda ? moneda.id : null;

        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data.moneda_id = monedaId;

        return data;
    }

    setData(data) {
        const { action } = this.props;
        // (TODO) se usa?
        // if (action === 'EDIT' && data.tieneventa) {
        //     return {
        //         allowed: false,
        //         message: 'No puede editar una reserva asociada a una venta. Intente editar la venta correspondiente.'
        //     };
        // }
        
        if (data.success) {
            this.setState({
                fecha: moment(data.fecha),
                vendedor_id: data.vendedor ? data.vendedor.id : null,
                cliente_id: data.cliente ? data.cliente.id : null,
                loteo_id: data.loteo ? data.loteo.id : null,
                lote_id: data.lote ? data.lote.id : null,
                comentarios: data.comentarios,
                moneda: data.moneda,
                monto: data.monto,
                seña: data.seña,
                cantidadCuotas: data.cantidadCuotas,
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Reserva",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Reserva ha sido creada con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Reserva",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Reserva ha sido editada con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Reserva",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Reserva",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Reserva ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: 'Eliminar',
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    setVendedor = () => {
        const { action } = this.props;
        if (action === 'CREATE') {
            const userId = localStorage.id;
            if (userId) {
                this.setState({
                    vendedor_id: userId,
                });
            }
        }
    }

    onLoteoChange = (loteo) => {
        // Se setean tanto el loteo como su moneda preferida.
        // (Nota) La moneda tiene que poder cambiarse, la del loteo es solo
        // un default.
        const loteoId = loteo ? loteo.id : null;
        const monedaPreferida = loteo && loteo.moneda_preferida
            ? loteo.moneda_preferida
            : this.findMoneda(Monedas.PESOS);
        this.onChangeField('loteo_id', loteoId)
        this.onChangeField('lote_id', null)
        this.onChangeField('moneda', monedaPreferida)
    }

    onMonedaChange = (moneda) => {
        this.onChangeField('moneda', moneda)
    }

    render() {
        let vars = this.modalVars();
        const {
            fecha,
            vendedor_id,
            cliente_id,
            loteo_id,
            lote_id,
            comentarios,
            moneda,
            monto,
            seña,
            cantidadCuotas
        } = this.state;
        const { action } = this.props;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.ventas.reservas : null)}
                submitUrl={(vars.submitType ? api.ventas.reservas : null)}
                submitType={vars.submitType}
                id={vars.id}

                onOpen={this.setVendedor}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}

                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveButtonLabel={vars.saveButtonLabel}
                closeButton={true}

                className="ui-paradigma-modal ui-paradigma-modal-wide"
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Identificación</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Fecha"}
                            inputComponent={
                                <ParadigmaDatePicker
                                    disabled={vars.disabled}
                                    value={fecha}
                                    onChange={data => this.onChangeField('fecha', data)}
                                />
                            }
                            error={() => this.getError('fecha')}
                        />
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Vendedor"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    displayField="apellido_nombre"
                                    url={api.vendedores.usuarios}
                                    parameters={{
                                         paginationEnabled:false,
                                    }}
                                    disabled={vars.disabled}
                                    value={vendedor_id}
                                    onChange={data => this.onChangeField('vendedor_id', (data) ? data.id : null)}
                                />
                            }
                            error={() => this.getError('vendedor_id')}
                        />
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos del comprador</p>
                    <div className="ui-form-grid">
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Cliente"}
                                inputComponent={
                                    <div className="ui-async-action-field">
                                        <ParadigmaAsyncSeeker
                                            clearable={true}
                                            url={api.clientes.select}
                                            parameters={{
                                                paginationEnabled:false,
                                                sort:['apellido'],
                                            }}
                                            disabled={vars.disabled}
                                            value={cliente_id}
                                            displayField="nombre_completo"
                                            onChange={data => this.onChangeField('cliente_id', (data) ? data.id : null)}
                                            CreateComponent={action != "DETAIL" ? props => <ModalCliente {...props} action="CREATE"/> : null}
                                        />
                                    </div>
                                }
                                error={() => this.getError('cliente_id')}
                            />
                        </div>
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos de la reserva</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Loteo"}
                            inputComponent={
                                <div className="ui-async-action-field">
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        url={api.loteos.loteos_select}
                                        parameters={{
                                            paginationEnabled:false,
                                            sort:['nombre']
                                        }}
                                        disabled={vars.disabled || action!='CREATE'}
                                        value={loteo_id}
                                        onChange={this.onLoteoChange}
                                        DetailComponent={loteo_id ? (props => <ModalLoteo {...props} action="DETAIL" activeTab={3} />) : null}
                                    />
                                </div>
                            }
                            error={() => this.getError('loteo_id')}
                        />
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Lote"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    optionRenderer={opts => `${opts.manzana} - ${opts.numero}`}
                                    url={loteo_id ? api.loteos.lotes : ''}
                                    parameters={{
                                            id:loteo_id,
                                            paginationEnabled:false,
                                            sort:['manzana'],
                                            concat: (loteo_id != undefined && action=='CREATE') ? (vendedor_id ? `vendido=False&reservado=False&vendedor_id=${vendedor_id}` : 'vendido=False&reservado=False') : '',
                                    }}
                                    valueRenderer={opts => `Manzana: ${opts.manzana} - Número: ${opts.numero}`}
                                    disabled={vars.disabled || !loteo_id || action!='CREATE'}
                                    value={lote_id}
                                    onChange={data => this.onChangeField('lote_id', (data) ? data.id : null)}
                                />
                            }
                            error={() => this.getError('lote_id')}
                        />
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Moneda"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        disabled={vars.disabled}
                                        clearable={false}
                                        url={api.monedas.monedas}
                                        parameters={{
                                            paginationEnabled:false,
                                        }}
                                        value={moneda ? moneda.id : null}
                                        onChange={this.onMonedaChange}
                                    />
                                }
                                error={() => this.getError('moneda')}
                            />
                        </div>
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Importes y cuotas</p>
                    <div className="ui-form-grid ui-form-grid-3">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Monto"}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    disabled={vars.disabled}
                                    className="form-control monto w-100"
                                    symbol={this.getMonedaSimbolo()}
                                    value={formatCurrency(monto >= 0 ? monto : Math.abs(monto))}
                                    onChange={data => this.onChangeField('monto', data)}
                                />
                            }
                            error={() => this.getError('monto')}
                        />
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Seña"}
                            inputComponent={
                                <ParadigmaCurrencyInput
                                    disabled={vars.disabled}
                                    className="form-control monto w-100"
                                    symbol={this.getMonedaSimbolo()}
                                    value={formatCurrency(seña >= 0 ? seña : Math.abs(seña))}
                                    onChange={data => this.onChangeField('seña', data)}
                                />
                            }
                            error={() => this.getError('seña')}
                        />
                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Cuotas"}
                            type="integer"
                            value={cantidadCuotas}
                            maxLength={10}
                            onChange={e => this.onChangeField('cantidadCuotas', e.target.value)}
                            error={() => this.getError('cantidadCuotas')}
                        />
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Observaciones</p>
                    <div className="ui-form-grid">
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Comentarios"}
                                type="textarea"
                                value={comentarios}
                                onChange={e => this.onChangeField('comentarios', e.target.value)}
                                error={() => this.getError('comentarios')}
                            />
                        </div>
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label=""
                                error={() => this.getError('reserva')}
                                inputComponent={<span></span>}
                            />
                        </div>
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Reservas/Modal.js